<template>
  <modal v-if="showModal" @leave="closed = true" show-close-btn width="320px">
    <h2 class="font-bold text-sm mb-2">Sign up to the automation</h2>
    <p class="mb-6 text-sm leading-normal">
      Save time and increase referral income by signing up to the automated referral system. The system will suggest new referrals daily and will automatically update the status of your referrals. Why wait?
    </p>
    <button v-if="registrationLink" @click="openLink(registrationLink)" type="button" class="mb-6 py-3 px-6 w-48 bg-tertiary text-white rounded mr-4">Sign up now</button>
    <p class="text-sm leading-normal">
      <loader v-if="updating" />
      <a v-else class="underline cursor-pointer" @click="neverShowAgain()">Do not show this message again</a>
    </p>
  </modal>
</template>

<script>
import { find } from 'lodash'
import { mapState, mapActions } from 'vuex'
import api from '@/http'

export default {
  name: 'GrsRegistrationModal',

  data () {
    return {
      closed: false,
      updating: false
    }
  },

  props: ['page'],

  computed: {
    ...mapState([
      'profile_v2', 'system', 'selectedOffice'
    ]),
    network () {
      return find(this.system.networks, network => network.id === this.selectedOffice.network_id) || []
    },
    showModal () {
      if (this.closed === true || !this.network.data.systems_available) {
        return false
      }

      // Show modal only for selected networks
      if (!this.network.data.systems_available.includes('automatic-referrals')) {
        return false
      }

      if (this.profile_v2.hide_automated_referrals_modal) {
        return false
      }

      return this.page.product_module === 'App\\Members\\ProductModules\\ReferralsModule' && this.selectedOffice.automated_referrals_permission !== true
    },
    registrationLink () {
      return this.network.grs_registration_url
    }
  },

  methods: {
    ...mapActions(['displayToastNotification']),
    openLink (link) {
      if (link.length < 1) {
        return
      }
      if (!link.startsWith('http', 0)) {
        link = 'https://' + link
      }
      window.open(link, '_blank')
    },
    neverShowAgain () {
      this.updating = true
      api.patch('/update-notification-settings', {
        hide_automated_referrals_modal: true
      }).then(
        (response) => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Notification settings updated',
            info: 'Your notification settings have been updated successfully.'
          })
          this.updating = false
          this.closed = true
        }, (error) => {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Order',
            info: 'Error saving notification settings. ' + error.response.data.message
          })
          this.updating = false
        }
      )
    }
  }
}
</script>
